import { render, staticRenderFns } from "./orStaffManagement.vue?vue&type=template&id=dffa7556&scoped=true"
import script from "./orStaffManagement.vue?vue&type=script&lang=js"
export * from "./orStaffManagement.vue?vue&type=script&lang=js"
import style0 from "./orStaffManagement.vue?vue&type=style&index=0&id=dffa7556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa7556",
  null
  
)

export default component.exports